export default "__VITE_ASSET__zjA0aScn__"